import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { loadTermHolidayPeriods, deleteTermHoliday } from './actions';
import List from './List';
import authUtils from '../../auth/utils';
import Filter from './Filter';
class TermHolidayPeriods extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentDidMount() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;

		let filter;
		if (this.props.termId > 0) {
			filter = { termId: this.props.termId };
		} else {
			filter = { ...(this.props.pagination.filter || {}), termId: null };
		}

		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber }, this.props.termId);
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}


	handleDelete(id) {
		const onSuccessEvent = () => this.reloadData();
		this.props.deleteTermHoliday(id, onSuccessEvent);
	}

	reloadData() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	render() {
		const {termId, isReadonly } = this.props;
		return (
			<div>
				{!termId && <Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading} />}
				<List termId={ this.props.termId} isReadonly={isReadonly} onFetchData={this.handleListEvent} onDelete={this.handleDelete} data={this.props.data} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const termId = ownProps.termId;
	const {
		pagination,
		entities: { termHolidayPeriods, terms },
		auth: { currentUser }
	} = state;

	const termHolidayPeriodsPagination = (termId ? pagination.termHolidayPeriods[ownProps.termId] : pagination.termHolidayPeriods.all) || { ids: [], pageNumber: 1, pageSize: 10 };
	const term = termId && terms[termId];
	return {
		termId,
		data: termHolidayPeriodsPagination.ids.map(id => termHolidayPeriods[id]),
		pagination: termHolidayPeriodsPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'TermHolidayPeriod') || (term && term.isReadonly)
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadTermHolidayPeriods,
	deleteTermHoliday,
	initializeFilter: (data, fields) => initialize('termHolidayPeriodsFilter', data, fields)
})(TermHolidayPeriods);